import request from '@/utils/request'; // 列表

export function needpaychannelgames(data) {
  return request({
    url: '/needpaychannelgames',
    method: 'get',
    params: data
  });
} //新增

export function addneedpaychannelgame(data) {
  return request({
    url: '/addneedpaychannelgame',
    method: 'post',
    params: data
  });
}